// social-logins.service.ts
import { Injectable } from '@angular/core'
import { environment } from '../environments/environment'

declare const google: any

@Injectable({
  providedIn: 'root',
})
export class SocialLoginsService {
  private clientId = environment.GOOGLE_CLIENT_ID

  constructor() {
    this.initializeGoogleLogin()
  }

  private initializeGoogleLogin() {
    if (typeof google === 'undefined') {
      console.error('Google API not loaded.')
      return
    }

    google.accounts.id.initialize({
      client_id: this.clientId,
      ux_mode: 'popup',
      callback: (response: any) => this.handleGoogleLoginCallback(response),
    })
  }

  private handleGoogleLoginCallback(response: any) {
    const token = response.credential
    const payload = JSON.parse(atob(token.split('.')[1]))

    const user = {
      name: payload.name,
      email: payload.email,
      picture: payload.picture,
    }

    console.log('Decoded User Info:', user)
  }

  private createGoogleButtonWrapper() {
    const googleLoginWrapper = document.createElement('div')
    googleLoginWrapper.style.display = 'none'
    document.body.appendChild(googleLoginWrapper)

    google.accounts.id.renderButton(googleLoginWrapper, {
      type: 'icon',
      width: '200',
    })

    const googleLoginButton = googleLoginWrapper.querySelector(
      'div[role=button]'
    ) as HTMLElement

    return {
      click: () => googleLoginButton?.click(),
    }
  }

  public signInWithGoogle() {
    this.createGoogleButtonWrapper().click()
  }
}
